import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Checkbox from "@material-ui/core/Checkbox";

const headCells = [
    { id: "name", numeric: false, disablePadding: true, label: "HG Login" },
    {
      id: "credits",
      numeric: true,
      disablePadding: true,
      label: "Credits",
      align: "center",
    },
    {
      id: "createtime",
      numeric: true,
      disablePadding: true,
      label: "Create Time",
      align: "center",
    },
    {
      id: "accounts",
      numeric: true,
      disablePadding: true,
      label: "Accounts",
      align: "center",
    },
    {
      id: "servers",
      numeric: true,
      disablePadding: true,
      label: "Servers",
      align: "center",
    },
    {
      id: "uniqueServers",
      numeric: true,
      disablePadding: true,
      label: "Unique Servers",
      align: "center",
    },
    {
      id: "activeAccounts",
      numeric: true,
      disablePadding: true,
      label: "Active Accounts",
      align: "center",
    },
    {
        id: "taskcount",
        numeric: true,
        disablePadding: true,
        label: "Threads",
        align: "center",
      },
    {
      id: "contribution",
      numeric: false,
      disablePadding: true,
      label: "Active Contribution",
      align: "center",
    },
    {
      id: "password",
      numeric: false,
      disablePadding: true,
      label: "Secret",
      align: "center",
    },
  ];

export function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }} />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell>Details</TableCell>
      </TableRow>
    </TableHead>
  );
}
